import { render, staticRenderFns } from "./ExamMarkInputPage.vue?vue&type=template&id=304a59f4&scoped=true&"
import script from "./ExamMarkInputPage.vue?vue&type=script&lang=js&"
export * from "./ExamMarkInputPage.vue?vue&type=script&lang=js&"
import style0 from "./ExamMarkInputPage.vue?vue&type=style&index=0&id=304a59f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304a59f4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
